import { Component, Input } from "@angular/core";

import { LabeledCardConfig } from "@shared/models";
import { LowerCasePipe } from "@shared/pipes";

@Component({
  selector: "app-labeled-card",
  standalone: true,
  imports: [LowerCasePipe],
  templateUrl: "./labeled-card.component.html",
  styleUrl: "./labeled-card.component.scss",
})
export class LabeledCardComponent {

  @Input() config: LabeledCardConfig = {};

  onInfoIconClicked() {}
  onSettingsGearClicked() {}
}
